/* eslint-disable react/prop-types */
import React from 'react';
import { Col, Form, Skeleton } from 'antd';
import NaturalityField, { naturalityRules } from './naturality/index';

const { Item } = Form;

// Naturalidade como UF + Cidade, gravando "Cidade/UF" (GYR-1883, RN8/RN8.1).
const BadesulNaturality = ({
  input, loading, selectedBusinessUser, sizeMap,
}) => (
  <Col {...sizeMap[input.size]}>
    <Item
      name={input.value}
      label={input.name}
      rules={naturalityRules({
        required: !input.notRequired,
        getPersonName: (getFieldValue) => (input.value.startsWith('partner_')
          ? getFieldValue('partner_fullName') || selectedBusinessUser?.user?.civilPartner?.fullName
          : getFieldValue('fullName') || selectedBusinessUser?.user?.fullName),
      })}
    >
      {loading ? (
        <Skeleton.Button shape="square" active className="gyramais-input-skeleton" size="large" />
      ) : (
        <NaturalityField id={input.value} />
      )}
    </Item>
  </Col>
);

export default BadesulNaturality;
